<template>
  <div id="moduleA" class="modules" :class="{scroll:route.name === 'Step11'}">
    <div class="flex align-center justify-center logo-container" :class="{index:route.name==='ModuleA' || (route.name==='Form' && !scrolled), scrollShadow:scrolled,blurred:scrolled}">
      <img class="logo-img" src="../assets/images/logo.png" alt="logo">
    </div>

    <header v-if="route.meta['order'] > 0 && ![12, 13, 14].includes(route.meta['order']) ">
      <steps-belt />
    </header>

    <transition name="fade">
      <div v-if="route.meta['order'] === 0" id="genders">
        <div class="flex-column align-center overlay">
          <h1 class="flex-column justify-center align-center title">
            <span>First Choice</span>
            <span class="sub-title">どちらでシミュレーションされますか？</span>
          </h1>
          <div class="flex-column gender-buttons">
            <button @click="pushTo('Step1', {gender:'woman'})" class="text-center oval uppercase transition pointer">woman</button>
            <button @click="pushTo('Step1', {gender:'man'})" class="text-center oval uppercase transition pointer">man</button>
          </div>
        </div>
      </div>
    </transition>

    <router-view v-if="route.meta['order'] > 0" v-slot="{ Component }">
      <transition :name="transition" mode="out-in">
        <component :is="Component" class="steps" />
      </transition>
    </router-view>

    <transition name="slideUp">
      <app-footer v-if="route.meta['order'] > 0 && !isDialogVisible && ![12, 13, 14].includes(route.meta['order'])" />
    </transition>

    <transition name="fade">
      <app-dialog v-if="isDialogVisible" :step="route.name" />
    </transition>

    <transition name="fade">
      <app-alart-dialog v-if="isalartDialogVisible" :step="route.name" />
    </transition>

  </div>
</template>

<script>
import {ref, watch, computed, onMounted} from "vue"
import {useRoute} from "vue-router"
import {useStore} from "vuex";
import useRoutePush from "@/modules/moduleA/helpers/useRoutePush";
import AppFooter from "../components/footer/index"
import StepsBelt from "@/modules/moduleA/components/header/StepsBelt";
import AppDialog from "@/modules/moduleA/components/dialogs/Dialog";
import AppAlartDialog from "@/modules/moduleA/components/dialogs/alartDialog";

export default {
  name: "index",
  components:{AppDialog, StepsBelt, AppFooter, AppAlartDialog},
  setup(){
    const route = useRoute()
    const store = useStore()
    const {pushTo} = useRoutePush()
    const currentDialogComponent = ref(null)
    const transition = ref("out-left")

    const scrolled = computed(() => {
      return store.state.moduleA.scrolled
    })

    watch(() => route.meta, (to, from) => {
      if (to["order"] >= 1 && to["order"] <= 10 && from["order"] !== 11){
        transition.value = from["order"] < to["order"] ? 'out-left' : 'out-right'
      } else {
        transition.value = "fade"
      }
    })

    const isDialogVisible = computed(() => {
      return store.state.dialog
    })

    const isalartDialogVisible = computed(() => {
      return store.state.alartDialog
    })


    return {route, scrolled, transition, pushTo, isDialogVisible, currentDialogComponent, isalartDialogVisible}
  }
}
</script>
<style>
#moduleA .logo-container {
  height: 80px;
}
#moduleA .logo-container.index {
  background-color: white;
}
#moduleA .logo-container > img.logo-img {
  height: 40px;
}
#moduleA > header {
  width: 100%;
  margin: auto;
  overflow: hidden;
  max-width: 1060px;
}
#moduleA #genders {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/gender--pc.jpg");
  background-size: cover;
  background-position: center;
}
#moduleA #genders > .overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, rgba(255,255,255,1) 4%, rgba(255,255,255,0) 63%);
}
#moduleA #genders > .overlay > h1.title {
  margin-top: 100px;
  font-weight: 400;
  letter-spacing: 2px;
}
#moduleA #genders > .overlay > h1.title > span.sub-title {
  margin-top: 10px;
  letter-spacing: 1.3px;
  font-size: 1rem;
}
#moduleA #genders > .overlay > div.gender-buttons > button {
  height: 50px;
  margin-top: 14px;
  color: black;
  background-color: white;
  width: 200px;
  font-size: .9rem;
}
#moduleA #genders > .overlay > div.gender-buttons > button:nth-child(1) {
  margin-top: 40px;
}
#moduleA #genders > .overlay > div.gender-buttons > button:hover {
  transform: translateY(-3px);
  background-color: rgba(0, 0, 0, .6);
  color: white;
  box-shadow: 0 1px 11px rgba(0, 0, 0, .3);
}

@media screen and (max-width: 736px) {
  #moduleA #genders {
    background-image: url("../assets/images/gender--sp.jpg");
  }
  #app > .modules.scroll {
      height: auto;
      padding-bottom: 50px;
  }
}
</style>
